// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__Uyp6D","selects":"Documents_selects__1t1hD"};